 <template>
  <SubContent @back="$router.go(-1)" height="625px" >
    <template v-slot:nav_left>
      {{tournamentListVo.tournamentName}}
      <span style="font-size:.16rem;margin-left:20px">赛事时间： {{tournamentListVo.matchTime | time}} 至 {{tournamentListVo.endTime | time}}</span>
    </template>
    <template v-slot:nav_right>
      <!--<div v-if=" userRole !== 'player' && tournamentListVo.matchReportStatus ==='COMPLETE' " class="download_btn" @click="download(tournamentListVo.uuid)">下载</div>-->
    </template>
    <div class="scroll_wrap">
      <vue-scroll v-show="!loading">
        <div class="item_title" style="padding-top:.2rem">
          <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">
          赛事信息
        </div>
        <div class="item">

          <div class="col">
            <span>赛事名称：{{tournamentListVo.tournamentName }}（{{tournamentListVo.matchType || '--' }}）</span>
            <span>球队：{{tournamentListVo.shortName}}</span>

          </div>
          <div class="col">
            <span>机构参赛球队名称：{{tournamentListVo.squadNowName}}</span>
            <span>是否高水平赛事：{{tournamentListVo.highLevel ? '是':'否'}}</span>
          </div>
          <div class="col" v-if="tournamentListVo.highLevel">
            <span>高水平赛事：{{tournamentListVo.tournamentName}}</span>
            <span>高水平赛事类型 / 组别：{{tournamentListVo.squadSex === "male" ? "男足" : tournamentListVo.squadSex === "mixed" ? "与其他单位球员联合组队" : "女足"}} / {{tournamentListVo.squadLevel}}</span>
          </div>

          <div class="col">
            <span>赛事地点：{{tournamentListVo.tournamentPlace}}</span>
            <span>赛事结果：第{{tournamentListVo.squadResult}}名</span>
          </div>
          <div class="col" v-if="tournamentListVo.fileUrl">
            <span>赛事秩序册文件：<a
              :href="$yioksConfig.transferBaseOnly(tournamentListVo.fileUrl)"
              target="_blank"
              :title="tournamentListVo.fileName"
              style="font-size: 16px;line-height: 1.2em;margin-bottom: 10px;color:#4cd964"
            >{{ tournamentListVo.fileName }}</a></span>

          </div>
          <div class="col">
            <span >赛事总体描述：<p style=" margin-top: .05rem" v-html="tournamentListVo.tournamentEvalComment"></p></span>
          </div>
<!--          <div class="col">-->
<!--            <span>比赛报告总体描述：<p style=" margin-top: .05rem" v-html="tournamentListVo.overallEvalComment"></p></span>-->
<!--          </div>-->
        </div>
        <div>
          <div class="item_title">
            <img src="@/assets/images/common/link_icon.png" style="width:.2rem;height.2rem" alt="">
            比赛总结
          </div>
          <div class="item">
            <div class="col">
              <span>{{tournamentListVo.squadSummary}}</span>
            </div>
          </div>
          <div>
            <div class="item_title">
              <img src="@/assets/images/common/player_information.png" style="width:23px;height:26px" alt="">

              比赛场次报告<div style="font-size:18px">（数量：{{matchReportListVos.length}}个）</div>
            </div>
            <div>
              <div class="item" style="margin-bottom: 5px">
                <template v-for="(item,index) in matchReportListVos">
                  <div class="col">
                    <span style="width:80%">比赛场次 {{ index+1 }}：{{item.matchTime | time}} 对阵 {{item.vs}}</span>
                    <div @click="goDetail(item.uuid)" style="color:#4CD964;cursor:pointer">查看报告</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </vue-scroll>
      <yioks-loading v-if="loading"></yioks-loading>
    </div>
  </SubContent>
</template>

<script>

import person from '@/assets/images/common/person.jpg'
import match from '@/api/match'
import storage from '@/utils/storage'
import common from '@/api/common'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'

export default {
  components: {
    'SubContent': () => import('@/components/layout/newSubContent')
  },
  filters: {
    dataEmpty (val) {
      if (!val) return '--'; else  return val;
    },
  },
  data () {
    return {
      person,
      playImg,
      planImg,
      downIng: false,
      loading: true,
      tournamentUuid: this.$route.query.uuid,
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      tournamentListVo: {},
      matchReportListVos: [],
      videoToPlayerVos: [],
    }
  },
  created () {
    this.getMatchDetail()
  },
  methods: {
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    getMatchDetail () {
      match.getMatchReportDetailTournament(this.tournamentUuid).then(res => {
        this.loading = false
        if (res.code) {
          this.$message.error('比赛不存在')
          this.$router.push('/home/index')
        } else {
          this.tournamentListVo = res.tournamentListVo
          this.matchReportListVos = res.matchReportListVos
        }
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },
    download (uuid) {
      if (this.downIng) return
      this.downIng = true
      match.downloadMatchReport(uuid).then(res => {
        const { fileName, filePath } = res
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },

    goDetail (uuid) {
      this.$router.push({
        path: "detail",
        query: {
          uuid,
        },
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .download_btn
    background $green_color2
    padding .05rem .2rem
    font-size .16rem
    cursor pointer
  .scroll_wrap
    flex 1
    overflow hidden
    box-sizing border-box
    padding .2rem 0
    .item_title
      display flex
      align-items center
      font-size .2rem
      padding .4rem 0 .2rem
      margin 0 .3rem
      span
        margin-left .4rem
        font-size .16rem
      img
        margin-right .1rem
    .item
      border 1px solid #FFF
      margin 0 .3rem
      .head
        font-weight bold
      .center
        text-align center
      .col
        display flex
        border-bottom 1px solid #FFF
        justify-content space-around
        padding .1rem .2rem
        span
          width 100%
        &:last-child
          border none
    .item_link
      border 1px solid #FFF
      margin 0 .3rem
      .col
        display flex
        border-bottom 1px solid #FFF
        &:last-child
          border none
        .title
          width: 1.5rem;
          padding .1rem .05rem
        .flex
          flex 1
          padding .1rem .2rem
          border-left 1px solid #FFF
    .trainPlan
      display flex
      justify-content space-between
      flex-wrap wrap
      margin: 0 .3rem;
      .planDetail
        border  1px solid white
        width 100%
        .row
          min-height 49px
          display flex
          align-items center
          border-bottom 1px solid white
          &:last-child
            border-bottom none
          .col
            width:  50%
            padding 0 10px 0 20px
            height 100%
            line-height 49px
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            &:first-child
              border-right  1px solid white
        .rowLine
          padding: 10px  10px  10px 20px
      .mediaDetail
        background-color rgba(0,0,0,0.7)
        border  1px solid white
        padding  20px
        width 400px
        display flex
        align-items center
        cursor pointer
        margin-bottom 20px
        .p_item
          margin-bottom 10px
      .img
        width 170px
        height 100px
        position relative
        .coverImg
          width 100%
          height 100%
      .intro
        padding-left 10px
        width: calc(100% - 170px);
        height 100px
        display flex
        flex-direction column
        justify-content space-between
    .item_squad
      border 1px solid #FFF
      margin 0 .3rem .2rem
      border-right 0
      display flex
      .flex
        flex 1
      .flex_center
        display flex
        flex-direction column
        justify-content center
        align-items center
        padding 0 .1rem
        border-right 1px solid #FFF
        img
          width .6rem
          height .6rem
          border-radius 50%
          margin-bottom .1rem
        p
          margin-bottom .1rem
      .head,.content
        padding: 0.1rem 0.2rem;
        border-right 1px solid #FFF
        border-bottom 1px solid #FFF
      .content
        min-height .6rem
      .col
        display flex
        justify-content space-around
        border-bottom 1px solid #FFF
        &:last-child
          border none
        span
          width 100%
          text-align center
          border-right 1px solid #FFF
          padding .1rem .2rem

.left-wrapper
  width 100%
  .up-wrapper
    display flex
  .down-wrapper
    .line
      display flex
      border-bottom 1px solid #FFF
      &:last-child
        border-bottom none
      .title-item
        width 100%
        border-right 1px solid #FFF
        padding .1rem .2rem
        display flex
        justify-content center
        align-items center

.player-box
  border 1px solid #FFF
  display flex
  margin 0 .3rem .2rem
  .left-info-box
    width 205px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .head-img-box
      width 100%
      display flex
      flex-direction column
      justify-content center
      align-items center
      .head-img
        width 80px
        height 80px
        border-radius 80px
        margin 0 10px 20px
    .select-box
      margin-top 20px
      padding 5px 10px
      .head-input-label
        display flex
        flex-direction column
        .head-input-label-text
          display flex
          align-items center
          justify-content center
  .right-info-box
    border-left 1px solid #FFF
    width 100%
    .row
      width 100%
      border-bottom 1px solid #FFFFFF
      padding 15px 10px
      display flex
      &:last-child
        border-bottom none
      .label-wrapper
        width 95px
        text-align right
      .input-wrapper
        padding 0 10px
        display flex
        width: 100%
        .input-style
          width 100%

.img-box
  padding 0rem 0 .2rem
  margin 0 .3rem
  img
    width 100%
    max-height: 500px
    max-width: 830px

</style>
